import { render, staticRenderFns } from "./FormatRegister.vue?vue&type=template&id=1e7fd96e&scoped=true"
import script from "./FormatRegister.vue?vue&type=script&lang=js"
export * from "./FormatRegister.vue?vue&type=script&lang=js"
import style0 from "./FormatRegister.vue?vue&type=style&index=0&id=1e7fd96e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7fd96e",
  null
  
)

export default component.exports